import { useTranslation } from 'react-i18next'
import { AlertCircle } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { useStoreNavigate } from '@/hooks/use-app-navigate'

/**
 * UpsellNotFound component
 * Displays when an upsell is not found
 */
export const UpsellNotFound = () => {
	const { t } = useTranslation('upsells')
	const { storeRoutes, navigate } = useStoreNavigate()

	return (
		<div className="bg-background min-h-screen flex items-center justify-center">
			<Alert variant="destructive" className="max-w-md">
				<AlertCircle className="h-4 w-4" />
				<AlertTitle>{t('notFound')}</AlertTitle>
				<AlertDescription>
					{t('notFoundDescription')}
				</AlertDescription>
				<div className="mt-4">
					<Button
						variant="outline"
						size="sm"
						onClick={() => navigate(storeRoutes.UPSELLS())}
					>
						{t('actions.backToUpsells')}
					</Button>
				</div>
			</Alert>
		</div>
	)
}

